// extracted by mini-css-extract-plugin
module.exports = {"container":"HeroTooltipCard-module__container--1CnBS","title":"HeroTooltipCard-module__title--1DSz9"};